export const SettingDefinitionQueryKeys = {
  all: () => ["setting-definitions"],
};
